import { render, staticRenderFns } from "./workloglist.vue?vue&type=template&id=53b8a56b&scoped=true&"
import script from "./workloglist.vue?vue&type=script&lang=js&"
export * from "./workloglist.vue?vue&type=script&lang=js&"
import style0 from "./workloglist.vue?vue&type=style&index=0&id=53b8a56b&scoped=true&lang=css&"
import style1 from "./workloglist.vue?vue&type=style&index=1&id=53b8a56b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b8a56b",
  null
  
)

export default component.exports